import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import AdminLeads from "./pages/AdminLeads";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsConditions from "./pages/TermsConditions";
import SellerQuestionnaire from "./pages/SellerQuestionnaire";
import InvestingInYourTomorrow from "./pages/InvestingInYourTomorrow";
import ScrollToTop from "./components/ScrollToTop";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/sell-my-house" element={<SellerQuestionnaire />} />
          <Route path="/why-knotts" element={<InvestingInYourTomorrow />} />
          <Route path="/investing-in-your-tomorrow" element={<Navigate to="/why-knotts" replace />} />
          <Route path="/admin/leads" element={<AdminLeads />} />
          <Route path="/admin/questionnaires" element={<Navigate to="/admin/leads" replace />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-conditions" element={<TermsConditions />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
      <div className="noise-overlay" aria-hidden="true" />
    </div>
  );
}

export default App;
